import { atom } from 'jotai';

export enum HeaderCenter_State {
  ELEMENT = 'ELEMENT',
  EXTRACT = 'EXTRACT',
  LIBRARY = 'LIBRARY',
  UPLOAD_ANYTHING = 'UPLOAD_ANYTHING',
  TRANSFORM = 'TRANSFORM',
  COMPONENT = 'COMPONENT',
  SETTINGS = 'SETTINGS',

  NONE = 'NONE',
}
export const headerCenter_currentState_Atom = atom<HeaderCenter_State>(HeaderCenter_State.NONE);
